import { prop } from 'ramda';
import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { usePrevious } from 'js/hooks/usePrevious';
import { useCustomSelector } from 'js/store/hooks';
import { POPUPS_REDUCER } from 'js/store/constants';

export const useDispatchPopupRendered = () => {
    const popups = useCustomSelector(POPUPS_REDUCER, prop('popups'));
    const popupsLength = Object.keys(popups).length;
    const prevPopupsLength = usePrevious(popupsLength);
    const isPopupCountIncreased = popupsLength > prevPopupsLength;

    useEffect(() => {
        if (isPopupCountIncreased) {
            dispatcher.dispatch('popup:rendered');
        }
    }, [isPopupCountIncreased]);
};
